import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import Cookies from "js-cookie";
import { Constants } from "@socialcoach/services";

const client = axios.create({});

client.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const responseURL = error.response?.request?.responseURL || "";
    const status = error.response?.status;
    const isAlreadyOnSignIn = window.location.pathname === "/sign-in";
    const isLoginApiCall = responseURL.includes("login");
    const skipAuthRedirect = error.config?.skipAuthRedirect;

    console.log("error", error);
    if (status === 401 && !isLoginApiCall && !skipAuthRedirect) {
      Cookies.remove(Constants.COOKIE_NAME);
      if (!isAlreadyOnSignIn) {
        window.location.href = "/sign-in?expired=true";
      }

      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

client.interceptors.request.use(config => {
  config.headers["x-request-id"] = uuidv4();
  return config;
});

export { client };
